export const PAX_TYPE = {
  adult: "ADT",
  child: "CHD",
  infant: "INF",
};

export const PASSENGER_TYPE = {
  [PAX_TYPE.adult]: "Adult",
  [PAX_TYPE.child]: "Child",
  [PAX_TYPE.infant]: "Infant",
};
